import { render, staticRenderFns } from "./DeckPage.vue?vue&type=template&id=4fe9f4d9&scoped=true&"
import script from "./DeckPage.vue?vue&type=script&lang=js&"
export * from "./DeckPage.vue?vue&type=script&lang=js&"
import style0 from "./DeckPage.vue?vue&type=style&index=0&id=4fe9f4d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9f4d9",
  null
  
)

export default component.exports